import React from 'react';
import PropTypes from 'prop-types';

const RadioWhatIf = ({
  value,
  label,
  ...props
}) => (
  <label
    className="
      what-ifs-radio-container
      what-ifs-label-text"
    htmlFor={`id-${value}`}
  >
    <span className="
      what-ifs-label-text
      what-ifs-radio-label-text"
    >
      {label}
    </span>
    <input
      id={`id-${value}`}
      type="radio"
      name="radioWhatIf"
      value={value}
      {...props}
    />
    <span className="what-ifs-radio-checkmark" />
  </label>
);

RadioWhatIf.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
};

export default RadioWhatIf;
